// components/auth/UserDropdownMenu.tsx
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { User, Settings, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface UserDropdownMenuProps {
  onLogout: () => void;
}

export const UserDropdownMenu = ({ onLogout }: UserDropdownMenuProps) => {
  const navigate = useNavigate();

  return (
    <>
      <DropdownMenuItem 
        onClick={() => navigate('/settings')}
        className="cursor-pointer focus:bg-theme-primary/10 focus:text-primary "
      >
        <User className="mr-2 h-4 w-4" />
        <span>Profile</span>
      </DropdownMenuItem>
      <DropdownMenuItem 
        onClick={() => navigate('/settings')}
        className="cursor-pointer focus:bg-theme-primary/10 focus:text-primary"
      >
        <Settings className="mr-2 h-4 w-4" />
        <span>Settings</span>
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem 
        onClick={onLogout} 
        className="cursor-pointer text-red-600 dark:text-red-400 focus:!bg-red-100 focus:!text-red-700 dark:focus:!bg-red-950 dark:focus:!text-red-400"
      >
        <LogOut className="mr-2 h-4 w-4" />
        <span>Logout</span>
      </DropdownMenuItem>
    </>
  );
};
